// Phase 1A Phase 9A.8 — Signal formatting helpers.
//
// Pure deterministic value-formatters extracted from MarketSignalCard,
// SignalDetailDrawer, and ExchangeFootballPage. NO React, NO Supabase,
// NO browser APIs, NO clock reads, NO side effects, NO styling. Every
// helper is module-pure and returns a string.
//
// Behaviour mirrors the existing inline copies bit-for-bit. This is a
// pure dedup refactor — no copy or formatting change intended.
//
// Function inventory:
//   - fmtPct(n, decimals)
//   - fmtPctSigned(n, decimals)
//   - fmtNum(n, decimals)
//   - fmtTier(tier)
//   - fmtKickoff(iso)
//   - statusLabel(status)
//
// `edgeStyle`, `statusStyle`, `confidenceDots`, `formatSignalCountdown`,
// `signalStatusFromKickoff`, and `getInvalidationCopy` deliberately stay
// in their existing modules — they own styling, math, or copy contracts
// that don't belong to a generic format layer.

import type { SignalStatus } from "./probability-math.ts";

export function fmtPct(n: number | null, decimals: number): string {
  if (n === null || !Number.isFinite(n)) return "—";
  return `${n.toFixed(decimals)}%`;
}

export function fmtPctSigned(n: number | null, decimals: number): string {
  if (n === null || !Number.isFinite(n)) return "—";
  const sign = n > 0 ? "+" : "";
  return `${sign}${n.toFixed(decimals)}%`;
}

export function fmtNum(n: number | null, decimals: number): string {
  if (n === null || !Number.isFinite(n)) return "—";
  return n.toFixed(decimals);
}

export function fmtTier(tier: number): string {
  if (tier === 1) return "Tier 1";
  if (tier === 2) return "Tier 2";
  if (tier === 3) return "Tier 3";
  return "—";
}

export function fmtKickoff(iso: string | null): string {
  if (iso === null) return "Kickoff time unknown";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toUTCString();
}

export function statusLabel(status: SignalStatus): string {
  if (status === "observing") return "Observing";
  if (status === "kickoff_passed") return "Kickoff passed";
  return "Stale";
}
